import { inject, Injectable, Injector } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/common';

import {
  AiChatWorkContextPickerDialogComponent,
  type AiChatWorkContextPickerDialogData,
} from './components/ai-chat-work-context-picker-dialog/ai-chat-work-context-picker-dialog.component';

/** Work context picker dialog wrapper. */
@Injectable()
export class AiChatWorkContextPickerDialog {
  readonly #dialog = inject(DialogService);
  readonly #injector = inject(Injector);

  open(data: AiChatWorkContextPickerDialogData): DialogRef {
    return this.#dialog.open(AiChatWorkContextPickerDialogComponent, data, {
      parentInjector: this.#injector,
      /**
       * Use custom backdrop/panel classes so the overlay.scss rule
       *   `.cdk-overlay-backdrop.cdk-overlay-backdrop-showing:not(:has(~ .pu-overlay-backdrop))`
       * does NOT hide the parent bot-popup overlay when the work context picker opens on top.
       * The custom classes share the same visual style as their pu-overlay-* equivalents.
       */
      overlayBackdropClass: 'pu-ai-license-picker-backdrop',
      /**
       * Intentionally NOT including `pu-overlay-panel` here.
       * overlay.scss hides any earlier `cdk-global-overlay-wrapper` whose later sibling
       * wrapper contains a child with `.pu-overlay-panel`.  Using a custom-only class keeps
       * the bot-popup wrapper visible (opacity: 1) while the work context picker is open.
       */
      panelClass: 'pu-ai-license-picker-panel',
    });
  }
}
